import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { setSnackbar } from "../../../store/commonActions";
import { useAppDispatch, useAppSelector } from "../../../utils/reduxUtil";

export const AppSnackbar = () => {
	const dispatch = useAppDispatch();
	const { snackbar } = useAppSelector((state) => ({
		snackbar: state.common.snackbar,
	}));

	const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
		if (reason === "clickaway") {
			return;
		}

		dispatch(setSnackbar(null));
	};

	return (
		<>
			{!!snackbar && (
				<Snackbar autoHideDuration={4000} open onClose={handleClose}>
					<Alert severity={snackbar.type} variant="filled">
						{snackbar.message}
					</Alert>
				</Snackbar>
			)}
		</>
	);
};
